/**
 * @desc 加油站对账明细分页
 */

import fetch from '@/utils/request'
import config from '@/config'

export interface QueryParams {}

export function request(data: defs.PageRequest<defs.ComeOnReconciliationQueryParameters>): Promise<BaseResponse<defs.ResultBean<Array<defs.TheReconciliationSubsidiaryEntities>>>> {
  return fetch({
    url: config.API_HOST + '/fuel/fee/stationReconciliationDetailPageList',
    data: data,
    method: 'POST',
    credentials: 'include',
    timeout: 20 * 1000,
  })
}
